module.exports = __webpack_public_path__ + "img/cielo.79ee0791.svg";